export default __webpack_public_path__ + "circle_selection_checked.a7a8aee2.svg";